<section class="flex flex-col m-2.5 flex-1">
    <app-management-list-header
        [actionEnabled]="canCreateRole()"
        [asSearch]="false"
        [subtitle]="
            `${rolesToDisplay() ? paginatedRoles()!.totalItems : 0} ${('role' | transloco: { COUNT: rolesToDisplay() ? paginatedRoles()!.totalItems : 0 })}`
                | lowercase
        "
        [title]="'role' | transloco"
        (actionClicked)="openCreateRoleModal()" />
    @if (rolesToDisplay()) {
        <app-custom-table
            class="m-2 flex-1 min-h-0 overflow-auto"
            [columns]="tableColumns"
            (sortEvent)="onSortChange($event)">
            @for (role of rolesToDisplay(); track role.id) {
                <tr
                    [class.selectedRole]="role.id === roleInPanel()"
                    (click)="toggleDetailPanel(role)">
                    @for (column of tableColumns; track column) {
                        <td>
                            @switch (column.key) {
                                @case ('name') {
                                    {{ role.name }}
                                }
                                @case ('createdAt') {
                                    {{ role.createdAt | date: translateService.localDate() }}
                                }
                                @case ('maxNumberOfAssignments') {
                                    {{ role.maxNumberOfAssignments ?? '-' }}
                                }
                                @case ('assigned') {
                                    {{ role.assignmentCount }}
                                }
                            }
                        </td>
                    }
                </tr>
            }
        </app-custom-table>
        <app-paginator
            #paginator
            [take]="paginatedRoles()!.take"
            [totalItems]="paginatedRoles()!.totalItems"
            (onPageChange)="onPaginationChange($event)" />
    } @else {
        <app-no-data-to-display
            displayedMessage="noRoles"
            iconSize="5x" />
    }
</section>
